import Contact from './Contact';

const index = {
  Contact,
};

export default index;